import { brandCodeMap } from '@/constants';
import { base } from '../base';

// export const timeLine = {
//   ...base,
//   timeLine: {
//     lineBgColor: base.color.c0005,
//     circleBgColor: base.color.c0017,
//   },
// };
const timeLineTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  timeLineTheme[item] = {
    timeLine: {
      lineBgColor: base[item]?.timeLineColor.c0005,
      circleBgColor: base[item]?.timeLineColor.c0017,
      lineCulomnBgColor: base[item]?.timeLineColor.c0003,
    },
  };
}

export const timeLine = timeLineTheme;
